import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import logger from '@leaflink/snitch';
import { DatadogTransport } from '@leaflink/snitch/transports/datadog.js';

import { useAppConfigStore } from '@/piniaStores/appConfig/appConfig.store';

import { useAuthStore } from './piniaStores/auth/auth.store';

export function loadDatadogRum() {
  const appConfigStore = useAppConfigStore();

  if (
    !appConfigStore.hasDatadogRumLoaded &&
    !window.Cypress &&
    import.meta.env.VITE_DATADOG_RUM_ENABLED === 'true' &&
    window?.navigator?.userAgent !== 'cypress-test'
  ) {
    datadogRum.init({
      applicationId: import.meta.env.VITE_DD_RUM_APPLICATION_ID,
      clientToken: import.meta.env.VITE_DD_RUM_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'marketplace-web',
      env: appConfigStore.environment,
      version: import.meta.env.VITE_RELEASE_VERSION,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 50,
      trackUserInteractions: true,
      trackFrustrations: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      // Connect RUM with Trace
      // https://docs.datadoghq.com/real_user_monitoring/connect_rum_and_traces/?tab=browserrum
      allowedTracingUrls: [
        // unified api
        // TODO: Allow DD RUM-specific request header fields
        // /https:\/\/(staging-)?api.leaflink.com\/\.*/,
        // staging, prod: /api/internal, /c/
        /https:\/\/(.{1,}\.)?leaflink\.com\/(api\/internal|c)\/.*/,
        // PR envs: /api/internal, /c/
        /https:\/\/leaflink-\d{1,}.dev.leaflink.io\/(api\/internal|c)\/.*/,
      ],
      // https://docs.datadoghq.com/real_user_monitoring/connect_rum_and_traces?tab=browserrum#how-are-apm-quotas-affected
      traceSampleRate: 100,
    });

    // Initialize Datadog Logs
    if (import.meta.env.VITE_DATADOG_ENABLED === 'true') {
      datadogLogs.init({
        clientToken: import.meta.env.VITE_DD_RUM_CLIENT_TOKEN,
        service: 'marketplace-web',
        env: appConfigStore.environment,
        version: import.meta.env.VITE_RELEASE_VERSION,
      });

      // Add Datadog transport to logger
      logger.addTransport(new DatadogTransport({ datadogLogsInstance: datadogLogs }));
    }
  }

  appConfigStore.hasDatadogRumLoaded = true;
}

export function addDatadogRumUserData() {
  const appConfigStore = useAppConfigStore();
  const authStore = useAuthStore();

  if (!import.meta.env.VITE_DATADOG_RUM_ENABLED || !appConfigStore.hasDatadogRumLoaded || !authStore.userId) {
    return;
  }

  datadogRum.setUser({ id: authStore.userId });
}

export function startDatadogRumRecording() {
  const appConfigStore = useAppConfigStore();

  if (!import.meta.env.VITE_DATADOG_RUM_ENABLED || !appConfigStore.hasDatadogRumLoaded) {
    return;
  }

  return datadogRum.startSessionReplayRecording();
}
